import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const BLOG_SUBDOMAIN = "https://blog.svsnursingcollege.com/";

export default function BlogSection() {
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="blogs-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <Reveal>
            <span className="text-xs tracking-[0.3em] uppercase text-gold-muted font-mono">Insights</span>
            <h2 className="font-serif text-4xl sm:text-5xl text-navy mt-4">From our blog</h2>
            <p className="text-navy/60 mt-4 max-w-xl leading-relaxed">
              Articles, updates and stories on nursing education, careers and campus life.
            </p>
          </Reveal>
          <Reveal>
            <Link
              to="/blog"
              data-testid="visit-blog-btn"
              className="inline-flex items-center gap-2 rounded-full bg-navy text-sand font-semibold px-6 py-3.5 transition-transform duration-300 hover:scale-105 hover:bg-navy-light"
            >
              Visit our Blog <ArrowUpRight size={18} className="text-gold" />
            </Link>
          </Reveal>
        </div>

        {/* Live blog preview — auto-syncs with blog.svsnursingcollege.com */}
        <Reveal delay={0.1}>
          <div className="relative rounded-[2px] border border-navy/10 shadow-[0_20px_60px_rgba(10,30,77,0.08)] bg-white overflow-hidden">
            <iframe
              title="SVS College of Nursing Blog"
              src={BLOG_SUBDOMAIN}
              data-testid="blog-iframe"
              className="w-full border-0"
              style={{ height: "760px" }}
              loading="lazy"
            />
            {/* fade + CTA to full blog */}
            <div className="pointer-events-none absolute bottom-0 inset-x-0 h-28 bg-gradient-to-t from-white to-transparent" />
            <Link
              to="/blog"
              data-testid="blog-readmore-btn"
              className="absolute bottom-5 left-1/2 -translate-x-1/2 inline-flex items-center gap-2 rounded-full bg-navy text-sand font-semibold px-6 py-3 shadow-lg transition-transform duration-300 hover:scale-105 hover:bg-navy-light"
            >
              Read all articles <ArrowUpRight size={18} className="text-gold" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
